import axios from "axios";

export default {
    state: {
        voivodeships: [],
        filter: {}
    },
    getters: {
        VOIVODESHIPS: state => {
            return state.voivodeships;
        },
        VOIVODESHIPS_FILTER: state => {
            return state.filter;
        }
    },
    mutations: {
        SET_VOIVODESHIPS: (state, payload) => {
            state.voivodeships = payload;
        },
    },
    actions: {
        GET_VOIVODESHIPS: ({commit}) => {
            return new Promise((resolve, reject) => {
                axios
                  .get(`voivodeships`)
                  .then(({ data, status }) => {
                    if (status === 200) {
                        commit("SET_VOIVODESHIPS", data);
                        resolve(true);
                    }
                  })
                  .catch(error => {
                    reject(error);
                });
            });
        },
    }
}